module.exports = __webpack_public_path__ + "assets/images/notificationsHelp/firefox-116ce2e5e904b0c9afbe28e15512a169.png";